
import { Box } from 'ui/box';

import IconButton from 'components/partials/button/icon-button';

import type { CeebCodeChip as CeebCodeChipModel } from '../calculations-step.types';

import Icons from 'assets/icons';

export interface CeebCodeChipProps {
  chip: CeebCodeChipModel;
  onRemove: (id: string) => void;
}

/** One chip in the CEEB codes field: pending (spinner), matched (neutral), or unmatched (warning) — FR-15/17/18/19. */
const CeebCodeChip = ({ chip, onRemove }: CeebCodeChipProps) => {
  const isUnmatched = chip.status === 'unmatched';
  const isPending = chip.status === 'pending';

  return (
    <Box
      component="span"
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          borderRadius: '0.375rem',
          borderWidth: '1px',
          pl: 1.25,
          pr: 0.75,
          py: 0.5,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        },
        isUnmatched && {
          borderColor: 'tokens.critical.200',
          color: 'tokens.critical.600',
        },
        !isUnmatched && {
          borderColor: 'tokens.navy.200',
          color: 'tokens.gray.900',
        },
      ]}
      data-testid={`ceeb-code-chip-${chip.id}`}
      data-status={chip.status}
    >
      {chip.code}
      {isPending ? (
        <Icons.Spinner
          customClass="size-3 animate-spin text-gray-400"
          data-testid={`ceeb-code-chip-pending-${chip.id}`}
        />
      ) : (
        <IconButton
          icon={<Icons.Close />}
          variant={isUnmatched ? 'critical-text' : 'reserve-text'}
          size="baby"
          aria-label={`Remove CEEB code ${chip.code}`}
          onClick={() => onRemove(chip.id)}
          className="text-current size-3"
          data-testid={`ceeb-code-chip-remove-${chip.id}`}
        />
      )}
    </Box>
  );
};

export default CeebCodeChip;
